import React from "react";
import styled from "styled-components";
import { z } from "zod";
import { mixinSkins } from "../../../skins/shared/mixins/themeStyles";
import { SkinId } from "../../../skins/types";
import { riotProductSkin } from "../skins/riot-product";
import { Backdrop, BackdropBackground } from "../../../components/Backdrop";
import { Media } from "../../../components/Media";
import { Blade } from "../../../components/Blade";
import { BasicBladeSchema } from "../../../schemas/blades/BasicBlade";
import { AspectRatio } from "../../../components/AspectRatio";
import { getMediaAspectRatio } from "../../../functional/getMediaAspectRatio";
export const FullWidthImageContractSchema = BasicBladeSchema.extend({
    type: z.literal("fullWidthImage"),
});
const _FullWidthImage = ({ backdrop, ...bladeProps }) => {
    const { background } = backdrop || {};
    return (React.createElement(Blade, { "data-testid": "full-width-image", ...bladeProps },
        React.createElement(Backdrop, null, background && (React.createElement(BackdropBackground, null,
            React.createElement(AspectRatio, { ratio: getMediaAspectRatio(background, 16 / 9) },
                React.createElement(Media, { media: background, role: "presentation" })))))));
};
export const FullWidthImage = styled(_FullWidthImage) `
  ${mixinSkins({
    [SkinId.RiotProduct]: riotProductSkin,
})}
`;
//# sourceMappingURL=FullWitdthImage.js.map